import { ASSIGNMENTS } from 'constants/actionTypes';
import request from 'utils/request_ajax';

const requestContents = () => ({
  type: ASSIGNMENTS.DIRECT_ASSIGN.REQUEST,
});

export const receiveAssignments = ({
  assignments,
  companyName,
  isManuallyTextAssignmentReminders,
  metadata,
  pagination,
  urls,
  bulkPermissions,
  isCurrentAssignableExist,
}) => ({
  type: ASSIGNMENTS.DIRECT_ASSIGN.RECEIVE,
  assignments,
  companyName,
  isManuallyTextAssignmentReminders,
  metadata,
  pagination,
  urls,
  bulkPermissions,
  isCurrentAssignableExist,
});

export const receiveAssignmentsByPath = ({
  path_assignments,
  metadata,
  status,
}) => ({
  type: ASSIGNMENTS.ASSIGN_VIA_PATH.RECEIVE,
  metadata,
  path_assignments,
  status,
});

export function fetchAssignments(url) {
  return async dispatch => {
    dispatch(requestContents());
    const data = await request.get(url);
    dispatch(receiveAssignments(data));
  };
}

export function fetchAssignmentsByPath(url) {
  return async dispatch => {
    dispatch(requestContents());
    const data = await request.get(url);
    dispatch(receiveAssignmentsByPath(data));
  };
}
